import { Component, OnInit, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatTableDataSource,
} from "@angular/material";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { MedicalOrderScannType } from "../../../model/medical-order-scann-type";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { BillingClosePreBilling } from "../../../model/billing/billing-close-pre-billing";
import { BillingInvoiceManualService } from "src/app/services/billing/billing-invoice-manual/billing-invoice-manual.service";
import { ClientService } from "src/app/services/client.service";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { ClientFilter } from "src/app/model/client-filter";
import { BillingInvoiceManualSearchItem } from "src/app/model/billing/billing-invoice-manual-search-item";

@Component({
  selector: "app-billing-manual-list-dialog",
  templateUrl: "./billing-manual-list-dialog.component.html",
  styleUrls: ["./billing-manual-list-dialog.component.css"],
})
export class BillingManualListDialogComponent implements OnInit {
  loading: boolean = true;
  loadingAction: boolean;
  form: FormGroup;
  items: BillingInvoiceManualSearchItem[] = [];
  filterCompleteClients: FilterCompleteService<ClientFilter>;
  dataSource = new MatTableDataSource([]);
  displayedColumns: string[] = [
    "invoiceNumber",
    "invoiceDate",
    "amount",
    "alicuotsColumn"
  ];

  constructor(
    public dialogRef: MatDialogRef<BillingManualListDialogComponent>,
    private formBuilder: FormBuilder,
    private notificationToastService: NotificationToastService,
    private billingInvoiceManualService: BillingInvoiceManualService,
    private clientService: ClientService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.formBuilder.group({
      invoiceNumber: [null ],
      client: [null ],
    });
  }

  get f() {
    return this.form.controls;
  }

  get filteredClientsOptions() { return this.filterCompleteClients ? this.filterCompleteClients.filteredOptions : []; }

  async ngOnInit() {
    this.loading = true;
    await this.loadClients();
  }

  async search() {

    if( this.f.invoiceNumber.value == null && this.f.client.value == null ){
      this.notificationToastService.error(
        "Debe ingresar al menos un criterio de búsqueda",
        "Factura manual"
      );
      return;
    } else {
      this.items =
      await this.billingInvoiceManualService.getBillingInvoiceManualSearchItems(
        "",
        this.f.invoiceNumber.value,
        null,
        null,
        this.f.client.value != null? this.f.client.value.id : null,
        true);

    this.dataSource = new MatTableDataSource(this.items);
    }

  }

  async loadClients() {
    try {
      this.loading = true;
      this.clientService.getClientFilters().then((info) => {
        this.filterCompleteClients = new FilterCompleteService<ClientFilter>(
          info,
          this.form.controls.client
        );
        this.loading = false;
      });
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Factura manual"
      );
    }
  }

  cancel() {
    this.dialogRef.close(null);
  }

  async asociate(item: BillingInvoiceManualSearchItem) {
    this.dialogRef.close(item);
  }
}
